// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule-popup[data-v-0e2d3c7d]{display:none}.is-active[data-v-0e2d3c7d]{display:block}.rule-popup .popup-mask .popup__body .rule-list[data-v-0e2d3c7d]{max-height:50vh}.popup__header[data-v-0e2d3c7d]{flex-direction:column}.popup__header[data-v-0e2d3c7d],.popup__header__top[data-v-0e2d3c7d]{display:-webkit-box;display:-webkit-flex;display:flex}.popup__header__top[data-v-0e2d3c7d]{justify-content:space-between;padding:.38647rem}", ""]);
// Exports
module.exports = exports;
